/**
 * Tiny signal so any component (e.g. BetaBanner) can pop the FeedbackWidget
 * without prop drilling or a global event bus. Increment-only counter — the
 * widget's $effect re-fires on each change, no debouncing needed.
 */

let openCounter = $state(0);

export function openFeedback(): void {
  openCounter += 1;
}

export function getOpenCounter(): number {
  return openCounter;
}
